const AddOnForm = {
  initialize() {
    this.watchRemoveButtons()
    this.watchAddButtons()
    $("#add_on_disallow_deposit, #add_on_allow_deposit").on("change", this.toggleFormVisibility)
    return this.toggleFormVisibility()
  },

  toggleRequiredAddOnWarnings(inputs) {
    if ($(".js-visibility:checked").val() != "required") {
      $("#js-addon-info").addClass("hide")
      $("#js-addon-warning").addClass("hide")
      return
    }

    if (inputs.length > 0) {
      $("#js-addon-info").removeClass("hide")
      $("#js-addon-warning").addClass("hide")
    } else {
      $("#js-addon-info").addClass("hide")
      $("#js-addon-warning").removeClass("hide")
    }
  },

  toggleFormVisibility() {
    if ($("input[name=add_on\\[allow_deposit\\]]:checked").val() === "true") {
      $(".minimum-deposit-js").slideDown("fast")
      return $(this)
        .closest(".add-on-options-js")
        .addClass("minimum-deposit-open")
    } else {
      $(".minimum-deposit-js").slideUp("fast")
      return $(this)
        .closest(".add-on-options-js")
        .removeClass("minimum-deposit-open")
    }
  },

  watchAddButtons() {
    return $(".build-nested-association-button-js").on("click", event => {
      return Sprinkles.BuildNestedAssociationButton.build(event, () => {
        if ($(".line-to-hide-js").length === 1) {
          Sprinkles.Checkbox.set($(".toggle-checkbox-js"), false)
          this.transferDefaultToFirstVariation()
          Sprinkles.BuildNestedAssociationButton.build(event)
        }
      })
    })
  },

  watchRemoveButtons() {
    return $(".add-on-form-js").on("click", event => {
      if ($(event.target).hasClass("destroy-nested-association-button-js")) {
        event.preventDefault()
        Sprinkles.DestroyNestedAssociationButton.hideAndToggle(event)

        if ($(".line-to-hide-js").length === 1) {
          this.transferLastVariationToDefault()
          Sprinkles.DestroyNestedAssociationButton.hideAndToggle({
            target: $(".add-on-form-js .destroy-nested-association-button-js")
          })
        }
      }
    })
  },

  transferDefaultToFirstVariation() {
    $(".add-on-variation-price-js").val($(".add-on-price-js").val())
    $(".add-on-variation-total-available-js").val($(".add-on-total-available-js").val())
    return $(".add-on-fields-js").addClass("hide")
  },

  transferLastVariationToDefault() {
    $(".add-on-fields-js").removeClass("hide")
    $(".add-on-price-js").val($(".add-on-variation-price-js").val())
    return $(".add-on-total-available-js").val($(".add-on-variation-total-available-js").val())
  }
}

export default AddOnForm
